/**
 * Merges schema-generated defaults with optional hydrated initial values.
 */
export function mergeFormDefaultValues(
	schemaDefaults: Record<string, unknown>,
	initialValues?: Record<string, unknown>,
): Record<string, unknown> {
	if (initialValues == null) return { ...schemaDefaults };
	return { ...schemaDefaults, ...initialValues };
}
